module.exports = {
  src: __webpack_public_path__ + "assets/images/video-off-icon.a27ead437f100041.svg",
  width: 25,
  height: 25,
  toString: function() { return __webpack_public_path__ + "assets/images/video-off-icon.a27ead437f100041.svg"; }
};